import styled from "styled-components";
import { colors } from "../../../libs/themes";
import { glassMixin } from "../../../styles";
interface ScrollableListProps {
    scrollable: boolean;
}

// Container to position BigCard
export const Container = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;
    margin: 20px 0px 90px 0px;
    overflow: visible;
`;

// BigCard styling
export const BigCard = styled.div`
    width: 100%;
    position: relative;
`;

// Sidebar card styling
export const SidebarCard = styled.div`
    position: absolute;
    bottom: -60px;
    width: 95%;
    background: #ffffff;
    border-radius: 24px;
    padding: 0px 10px 0px 10px;
    gap: 56px;
    box-shadow: 0px 2px 12px 10px rgba(0, 0, 0, 0.2);

    ${({ theme }) => theme.glassMixin}
`;

// Example content inside the sidebar card
export const SidebarCardContent = styled.div`
    overflow-x: auto;
    white-space: nowrap;
    display: flex;
`;

// Arrow container shared style
export const ArrowContainer = styled.div`
    position: absolute;
    top: 45%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    background-color: white;
    border: 2px solid ${colors.border.black};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    ${glassMixin}
    background-color:rgb(184, 180, 180, 0.5);

    &:hover {
        transform: translateY(-50%) scale(1.1);
    }
`;

// Left arrow
export const ArrowLeft = styled(ArrowContainer)`
    left: -20px;
    z-index: 999;
`;

// Right arrow
export const ArrowRight = styled(ArrowContainer)`
    right: -20px;
    z-index: 999;
`;

export const ScrollableList = styled.div.withConfig({
    shouldForwardProp: (prop) => !["scrollable"].includes(prop),
})<ScrollableListProps>`
    display: flex;
    flex-direction: row;
    overflow-x: ${({ scrollable }) => (scrollable ? "scroll" : "hidden")};
    overflow-y: hidden;
    scroll-behavior: smooth;
    padding-right: 16px;
    border-radius: 24px;
    margin: 0 auto;
    //gap: 10px;

    ${({ scrollable }) =>
        scrollable &&
        `
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const SeeAllWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const SidebarCardWrapper = styled.div`
    padding: 10px 10px 10px 0px;
    &:first-child {
        padding-left: 10px;
    }
`;
